import { render, staticRenderFns } from "./DashboardChats.vue?vue&type=template&id=44637fbc&scoped=true"
import script from "./DashboardChats.vue?vue&type=script&lang=js"
export * from "./DashboardChats.vue?vue&type=script&lang=js"
import style0 from "./DashboardChats.vue?vue&type=style&index=0&id=44637fbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44637fbc",
  null
  
)

export default component.exports